import React, { useCallback, useEffect, useState } from "react";
import { Modal, Form, Input, message } from "antd";
import { loadCategories } from "../../../../../application/categories-slice";
import { useAppDispatch } from "../../../../../application/store";
import { CategoriesRepository, CategoryType } from "../../../../../domain";
import { ServiceLocater, Services } from "../../../../../service-locater";
import { logger } from "../../../../../utils";
import I18n from "../../../../i18n";

type EditCategoryModalProps = {
  visible: boolean;
  onClose: () => void;
  category?: { title: string; id: string };
  categoryType?: "category" | "subCategory" | "generalCategory";
};

const EditCategoryModal: React.FC<EditCategoryModalProps> = ({
  visible,
  onClose,
  categoryType,
  category,
}) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const stableSetFields = useCallback(form.setFields, []);
  useEffect(() => {
    stableSetFields([{ name: "title", value: category?.title }]);
  }, [stableSetFields, category]);

  const submit = async () => {
    try {
      await form.validateFields();
      if (category === undefined || categoryType === undefined) return;
      setIsLoading(true);
      let _categoryType: CategoryType;
      if (categoryType === "generalCategory") {
        _categoryType = "general";
      } else if (categoryType === "subCategory") {
        _categoryType = "sub";
      } else {
        _categoryType = "category";
      }
      const res = await ServiceLocater.get<CategoriesRepository>(
        Services.CategoriesRepository
      ).editCategory(_categoryType, category.id, form.getFieldValue("title"));
      setIsLoading(false);
      res.fold(
        (_) => {
          message.error(I18n.general.networkError);
        },
        (_) => {
          message.success("دسته‌بندی با موفقیت ویرایش شد.");
          dispatch(loadCategories());
          onClose();
        }
      );
    } catch (error) {
      logger.error(error);
    }
  };

  return (
    <Modal
      title={"ویرایش دسته بندی"}
      visible={visible}
      closable={!isLoading}
      maskClosable={!isLoading}
      onCancel={isLoading ? undefined : onClose}
      onOk={submit}
      confirmLoading={isLoading}
      bodyStyle={{ paddingBottom: 0 }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="title"
          label="عنوان"
          required
          rules={[
            { required: true, validateTrigger: "onSubmit", type: "string" },
          ]}
        >
          <Input defaultValue={category?.title} name="title" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditCategoryModal;
